module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-0648.15d8de66.jpg";